<template>
    <div class="row">
		<div class="col d-flex justify-content-center" v-for="(point, index) in config" :key="index">
			<a :href="point.url_to" class="wrapper-box text-center">
				<img
					class="box-img cursor-pointer"
					:src="point.image_url"
					:alt="'Landing'"
				/>
				<div class="box-label">
					{{ point.title }}
				</div>
			</a>
		</div>
    </div>
</template>
<script>
export default {
	name: 'SellingPoint',
	props: {
		config: {
			type: Array,
			default: () => [
				{
					title: 'Mudah Dimulai',
					image_url: 'https://cdn.ostock.id/icons/selling-points/landing.svg',
					url_to: 'https://google.com',
				},
				{
					title: 'Bantu Berkembang',
					image_url: 'https://cdn.ostock.id/icons/selling-points/marketing-kit.svg',
					url_to: 'https://google.com',
				},
				{
					title: 'Serba Terukur',
					image_url: 'https://cdn.ostock.id/icons/selling-points/production-scaleable.svg',
					url_to: 'https://google.com',
				},
				{
					title: 'Akses Optimal',
					image_url: 'https://cdn.ostock.id/icons/selling-points/big-product.svg',
					url_to: 'https://google.com',
				},
				{
					title: 'Tepat Sasaran',
					image_url: 'https://cdn.ostock.id/icons/selling-points/ad-copy.svg',
					url_to: 'https://google.com',
				},
			],
		},
	},
	data() {
		return {
		};
	},
};
</script>
<style lang="scss" scoped>

	a {
		&:hover {
			text-decoration: none;
		}
		&:active{
			text-decoration: none;
		}

		.wrapper-box {
			// border: 1px solid #5e5e5e;
			width: 217px;
			height: 162px;
			padding: 20px;
		}

		.box-img {
			width: 100%;
			height: auto;
			max-height: 100px;
			max-width: 100px;
			transition: transform 250ms;
			&:hover {
				transform: translateY(-10px);
			}

			@media screen and (max-width: 540px) {
				max-height: 40px;
			}
		}

		.box-label {
			margin-top: 5px;
			font-weight: 700;
			font-size: 20px;
			color: #1B1C1EDE;

			@media screen and (max-width: 540px) {
				font-size: 10px;
			}
		}
	}


</style>
